import { Component, OnInit, Inject } from '@angular/core';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { SharedServiceService } from '../../../shared-service.service';
import { AuthService } from '../../../services/auth.service';
import { SalesDashboardService } from '../../../services/sales-dashboard.service';

@Component({
  selector: 'app-modal-delete',
  templateUrl: './modal-delete.component.html',
  styleUrls: ['./modal-delete.component.scss']
})
export class ModalDeleteComponent implements OnInit {

  projectFromDashboardId: string = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ModalDeleteComponent>,
              public newProject: ProjectManagerService,
              public sharedService: SharedServiceService,
              public auth: AuthService,
              private salesDashboardService: SalesDashboardService
              ) { }

  deleteProject() {
    if(this.auth.getRole() == "admin") {
      this.newProject.deleteTemplate(this.data.project.id).subscribe(res => console.log(res));
      this.sharedService.broadcast('deleteTemplate', 'some message');
    }
    else {
      this.newProject.deleteProject(this.data.project.id).subscribe(res => console.log(res));
      this.sharedService.broadcast('deleteProject', 'some message');
    }
  }

  deleteProjectFromDashboard(){    
    this.newProject.deleteProject(this.projectFromDashboardId).subscribe(res => console.log(res));
    this.salesDashboardService.confirmProjectDelete(this.projectFromDashboardId);
    this.sharedService.broadcast('deleteProject', 'some message');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
    if(this.salesDashboardService.getSelectedProjectId()){
      this.projectFromDashboardId = this.salesDashboardService.getSelectedProjectId();
      this.salesDashboardService.clearSelectedProjId();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-delete/modal-delete.component.ts